
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Layout from "./components/Layout";
import Footnote from "./components/Footnote";
import Progress from "./components/Progress";
import SlideTitle from "./components/SlideTitle";
import Icon from "./components/Icon";
import Font from "./components/Font";
import {
  BLUE,
  RED,
  YELLOW,
  GREEN,
  PINK,
  DARK_BLUE,
  DARK_RED,
  DARK_YELLOW,
  DARK_GREEN,
  DARK_PINK,
  LIGHT_GREY,
  DARK_GREY,
  GREY,
  BLACK,
  WHITE
} from "./components/Colours.js";
import BG1 from "./images/bg1.jpg";
import BG2 from "./images/bg2.jpg";
import Brett from "./images/brett.jpg";
import SlideJourney from "./images/slide-journey.svg";
import SlideAreas from "./images/slide-areas.svg";
import SlideMarket from "./images/slide-market.svg";
import SlideComponents from "./images/slide-components.svg";
import AllTheGuidelines from "./images/all-the-guidelines.gif";
import CAT from "./images/climate-action-tech.png";
import CatJourney from "./images/cat-journey.png";
import Lighthouse from "./images/lighthouse.png";
import W3C from "./images/w3c.png";
import WebsiteCarbon from "./images/websitecarbon.png";
import QrCode from "./images/qrcode.png";
export { default as theme } from "./components/Theme";
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Footer = makeShortcode("Footer");
const Image = makeShortcode("Image");
const Notes = makeShortcode("Notes");
const Split = makeShortcode("Split");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <Footer mdxType="Footer">
      <Progress mdxType="Progress" />
    </Footer>
    <Layout mdxType="Layout">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Key`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Left Arrow, Page Up, Shift + Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to previous slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Right Arrow, Page Down, Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to next slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + P`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Presenter Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + O`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Overview Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + G`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Grid Mode`}</td>
          </tr>
        </tbody>
      </table>
      <div style={{
        display: "flex",
        marginTop: "50px",
        padding: "50px"
      }}>
        <p><a parentName="p" {...{
            "href": "https://github.com/tackaberry/ottawajs-w3c-web-sustainability-guidelines"
          }}>{`This presentation on github`}</a></p>
        <Image src={QrCode} style={{
          marginLeft: "50px",
          height: "200px",
          width: "200px"
        }} mdxType="Image" />  
      </div>
    </Layout>
    <hr></hr>
    <Layout color={DARK_GREY} mdxType="Layout">
      <h1>{`W3C Web Sustainability Guidelines`}</h1>
      <h3>{`For Ottawa Javascript`}</h3>
      <h3>{`November 15, 2023`}</h3>
      <h2>{`Brett Tackaberry, Principal Architect, Google Cloud Canada`}</h2>
    </Layout>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`Web Sustainability`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`All jobs are climate jobs. `}</p>
      <p>{`I want to help you understand how your work as web developers and designers can have a positive impact on the environment. `}</p>
      <p>{`Im going to start off with a little bit of my journey, the context, and then we’ll get into the new web sustainability guidelines, and then finish off with some practical ways you can start.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <Split mdxType="Split">
        <Image src={Brett} style={{
          height: "600px",
          width: "600px"
        }} mdxType="Image" />
        <h1>{`About me`}</h1>
        <p>{`help people do awesome things with technology`}</p>
        <p>{`help companies grow, help teams do better`}</p>
        <p>{`use technology make the world a better place`}</p>
      </Split>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`I'm Brett Tackaberry. `}</p>
      <p>{`I’m a principal architect at Google Cloud Canada.  I help people do awesome things with technology.   And right now, Im helping govt and the public sector do more in the cloud. `}</p>
      <p>{`Over my career I've spent lot of time building community helping to bring technology to the social sector.  I ran hackathons, ran tech4good, contributed to civic tech. This was and is important to me. `}</p>
    </Notes>
    <hr></hr>
    <Layout image={SlideJourney} mdxType="Layout">
      <SlideTitle mdxType="SlideTitle">My Journey</SlideTitle>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`More recently I have been spending my time finding ways to put my effort in to helping the climate crisis. `}</p>
      <p>{`When I was working at a company in town called Rebel, I started to introduce sustainability and green concepts into our offering. If you're not familiar we were a web hosting company, amongst other things. `}</p>
      <p>{`We made a few decisions that would result in less carbon footprint. `}</p>
      <p>{`For example, when AWS launched in Montreal, we launched new locations and set the default to Canada. `}</p>
      <p>{`Montreal data centres are powered with green energy - so, this had an impact. `}</p>
      <p>{`This kicked off more green initiatives with the team.`}</p>
      <p>{`For me, it inspired me to really evaluate how I can use my experience to work on climate.  `}</p>
      <p>{`I dove right in, learned a tonne, I moved to work with a company building enivronment and civic focused apps, and yes, now at google. But along the way contributing more to how we can build to a more sustainable internet.  `}</p>
      <p>{`I'm not an expert, but I'm going to share what I've learned so far.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={BLACK} image={BG2} mdxType="Layout">
      <h1>{`Context`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`First, let’s talk about the context.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={GREEN} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_one" mdxType="Icon" />{` 1.5 ºC`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The Paris agreement gave us the threshold to restrict global warming to no more than 1.5 degrees Celsius to mitigate the worst impacts of climate change`}</p>
      <p>{`So, we have to act now`}</p>
    </Notes>
    <hr></hr>
    <Layout color={RED} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_two" mdxType="Icon" />{` Carbon Footprint of ICT is Subtantial`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The digital industry is responsible for between 2 and 5 % of global emissions. `}</p>
      <p>{`If the internet were a country it would be one of the top 5 polluters.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_3" mdxType="Icon" />{`Our Industry is Growing`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`And with massive growth in AI, IoT,  we'll see it grow to well over 10% within the next 10 years. `}</p>
      <p>{`Since 2010, the number of internet users has more than doubled. Global traffic has increased by 25 times. `}</p>
      <p>{`And what’s more, page size more than doubled in some cases. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={BLACK} image={BG1} mdxType="Layout">
      <h1>{`Our Challenge`}</h1>
      <p>{`Our challenge is to divorce the growth of the usage of IT from its impact on the environment.`}</p>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`Architecture decisions we make`}</h1>
      <h1>{`have an `}<Font color={YELLOW} mdxType="Font">{`impact`}</Font></h1>
      <h1>{`on our environment`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`software engineers`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`designers`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`product owners`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`you`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`W3C Web Sustainability Guidelines`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Let's zoom back in a little bit and talk about some practical ways your work can have a positive impact on the environment.`}</p>
      <p>{`Let's talk about the W3C Web Sustainability Guidelines.`}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`Who is the W3C?`}</h1>
      <p>{`The World Wide Web Consortium (W3C) develops standards and guidelines to help everyone build a web based on the principles of accessibility, internationalization, privacy and security.`}</p>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The World Wide Web Consortium (W3C) develops standards and guidelines to help everyone build a web based on the principles of accessibility, internationalization, privacy and security.`}</p>
      <p>{`You might know them as the organization that published Web Content Accessibility Guidelines. And the WCAG is referenced all over the world and is the standard for accessibility.  `}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h3>{`W3C launched Draft 1.0 of the Web Sustainability Guidelines in September 2023.`}</h3>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The Web Sustainability Guidelines (WSG) 1.0 explains how to design and implement digital products and services that put people and the planet first. `}</p>
      <p>{`The guidelines are best practices based on measurable, evidence-based research; aimed at end-users, web workers, stakeholders, tool authors, educators, and policymakers.`}</p>
    </Notes>
    <hr></hr>
    <Layout light image={SlideAreas} mdxType="Layout">
      <SlideTitle mdxType="SlideTitle">Areas</SlideTitle>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The guidelines are holistic.`}</p>
      <p>{`They focus on Power, e-Waste, Water and Carbon traps. `}</p>
      <p>{`Carbon traps are things like dark data, the carbon footprint of the supply chain - the supply chain of digital products being people, offices, advertizing, and everything else that isn't related to the power consumption or embedded carbon of the device itself. `}</p>
    </Notes>
    <hr></hr>
    <Layout light image={SlideMarket} mdxType="Layout">
      <SlideTitle mdxType="SlideTitle">Audience</SlideTitle>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The guidelines were written with specific audiences in mind:`}</p>
      <p>{`They’re very practically useful for people in the industry. These people are us, and our stakeholders and customers.`}</p>
      <p>{`But our work will, in-turn raise awareness. Esp if we're building tools that are helping users gain efficiency and reduce their carbon footprint.`}</p>
      <p>{`And we have to be mindful that standards will create basis for regulations. We saw it with WCAG and accessibility laws. As orgs build compliance to laws, we see it propagate into procurement policies.  `}</p>
      <p>{`I think we’re going to see digtial and IT sustainability laws start to emnerge and they're going to be more strict and impactful. `}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`Stats`}</h1>
      <ul>
        <li parentName="ul">{`4 Categories - UX, Dev, Hosting, Business`}</li>
        <li parentName="ul">{`94 Guidelines`}</li>
        <li parentName="ul">{`232 Success Criteria`}</li>
        <li parentName="ul">{`many more resources and examples`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout light image={SlideComponents} mdxType="Layout">
      <SlideTitle mdxType="SlideTitle">Components</SlideTitle>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`A guideline would read: Enable asynchronous processing and communication. `}</p>
      <p>{`And this guideline has 2 success criteria:  Use batch processing, and perhaps run when power consumption would be at lower carbon-intensity- running in a predictable pattern keeps utilization optimized, reduces thrashing- avoids user-impact of slow downs and outages; and the second criterion is protocol usage - using more efficient, secure privacy -aware routes `}</p>
      <p>{`Theres Impact, Effort, benefits. GRI reporting alignment.  Examples and resources. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`User Experience and Design`}</h1>
      <h2>{`Research and ideation, journey design, content and assets, and quality assurance.`}</h2>
      <ul>
        <li parentName="ul">{`Research, consult, assess thoughtfully  and consider sustainability in early ideation`}</li>
        <li parentName="ul">{`Build automated value regression testing into the solution`}</li>
        <li parentName="ul">{`If you’re building apps or tools, there are a lot of guidelines for content and design considerations`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Research and ideation, journey design, content and assets, and quality assurance.`}</p>
      <p>{`If you’re building apps or tools, there are a lot of guidelines for content and design considerations`}</p>
      <p>{`Example: Analyze The Performance Of The Visitor Journey`}</p>
      <ul>
        <li parentName="ul">{`ethically measure how efficient a visitor's experience is`}</li>
        <li parentName="ul">{`only collect the data required to provide a streamlined and effective user-journey`}</li>
        <li parentName="ul">{`reduce the energy burden of loading unnecessary page`}</li>
      </ul>
      <p>{`Other examples:`}</p>
      <ul>
        <li parentName="ul">{`Use Recognized Design Patterns`}</li>
        <li parentName="ul">{`Avoid manipulative patterns`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`Web Development`}</h1>
      <h2>{`Development sustainability, code optimization, and security.`}</h2>
      <ul>
        <li parentName="ul">{`Mostly speaks to client-side technologies`}</li>
        <li parentName="ul">{`Building for security `}</li>
        <li parentName="ul">{`Taking this further: Building performance and sustainability testing into CI/CD, and operationalizing performance measurement`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Green software practices, code optimization, focussing mainly on client side technologies. `}</p>
      <p>{`Taking this further: Building performance and sustainability testing into CI/CD, and operationalizing performance measurement`}</p>
      <p>{`Example: 3.17 Manage Dependencies Appropriately`}</p>
      <ul>
        <li parentName="ul">{`on the client side, larger javascript package size and large downloads can cause very high emissions in terms of CPU load due to the rendering process`}</li>
        <li parentName="ul">{`check for unused dependencies`}</li>
        <li parentName="ul">{`keep dependencies up to date - up to date software is more secure and more efficient`}</li>
      </ul>
      <p>{`Other examples being: `}</p>
      <ul>
        <li parentName="ul">{`Minify Your HTML, CSS, and JavaScript`}</li>
        <li parentName="ul">{`Use Code-Splitting Within Projects`}</li>
        <li parentName="ul">{`Use Metadata Correctly`}</li>
        <li parentName="ul">{`Ensure Your Scripts Are Secure`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`Hosting, Infrastructure, and Systems`}</h1>
      <h2>{`Environment commissioning, minimizing environment and data, and minimizing human disruption.`}</h2>
      <ul>
        <li parentName="ul">{`Rightsizing, automation, batch processing`}</li>
        <li parentName="ul">{`Sustainable data practices, only keeping what’s needed`}</li>
        <li parentName="ul">{`Minimize transfer, use edge computing`}</li>
        <li parentName="ul">{`Async processing and computing`}</li>
        <li parentName="ul">{`Being carbon aware`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Environment commissioning, minimizing environment and data, and minimizing human disruption.`}</p>
      <ul>
        <li parentName="ul">{`Rightsizing, automation, batch processing`}</li>
        <li parentName="ul">{`Sustainable data practices, only keeping what’s needed`}</li>
        <li parentName="ul">{`Minimize transfer, use edge computing`}</li>
        <li parentName="ul">{`Async processing and computing`}</li>
        <li parentName="ul">{`Being carbon aware`}</li>
      </ul>
      <p>{`Example: 4.5 Limit Usage Of Additional Environments`}</p>
      <p>{`Decommission or switch off additional environments, such as testing, staging`}</p>
      <p>{`Other examples being:`}</p>
      <ul>
        <li parentName="ul">{`Choose a Sustainable Hosting Provider`}</li>
        <li parentName="ul">{`Optimize brower caching`}</li>
        <li parentName="ul">{`Automate`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">
      <h1>{`Business Strategy and Product Management`}</h1>
      <h2>{`Reporting, disclosure, strategy, and policies from both an organizational and website and product level.`}</h2>
      <ul>
        <li parentName="ul">{`Speaks to the business of building and operating a digital product`}</li>
        <li parentName="ul">{`Setting org-level sustainability goals`}</li>
        <li parentName="ul">{`Implementing sustainability onboarding training or guidelines`}</li>
        <li parentName="ul">{`Use open-source software`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Reporting, disclosure, strategy, and policies from both an organizational and website and product level.`}</p>
      <ul>
        <li parentName="ul">{`Speaks to the business of building and operating a digital product`}</li>
      </ul>
      <p>{`Examples being: `}</p>
      <ul>
        <li parentName="ul">{`Have an Ethical and Sustainability Product Strategy`}</li>
        <li parentName="ul">{`Define Clear Organizational Sustainability Goals and Metrics`}</li>
        <li parentName="ul">{`Implementing sustainability onboarding training or guidelines`}</li>
        <li parentName="ul">{`Use open-source software`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`Using the Guidelines`}</h1>
      <ul>
        <li parentName="ul">{`Links in this repo`}</li>
        <li parentName="ul">{`Quick reference - look for High Impact with Low and Medium Effort`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The guidelines are constructed in way that makes it fairly easy to adopt and use.  The concepts are simple.  There are a number of resources and links in the repo. `}</p>
      <p>{`Theres a quick reference guide that works like a checklist.  Start with the High Impact with Low and Medium Effort items and work your way down.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={WHITE} light mdxType="Layout">
      <h1>{`What does a journey look like?`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Its going to seem daunting. It's a journey.  And you can start small.  And you can start today. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">
      <h1>{`1. Measure and experiment`}</h1>
      <ul>
        <li parentName="ul">{`Measure poewr consumption of your software - client and server side`}</li>
        <li parentName="ul">{`Lighthouse - Google Chrome Dev Tools`}</li>
        <li parentName="ul">{`Website Carbon - Measure the carbon footprint of your website`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`If you're just getting started, your first step will be an assessment. You can't improve what you don't measure.   There are a number of tools that can help you understand the carbon impact of your software.  `}</p>
      <p>{`I've only listed a couple here but there are many more. `}</p>
      <p>{`For this talk Im just going to hover around client side, but I have something for folks that want more on cloud sustainability. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">  
      <Split mdxType="Split">
        <Image src={Lighthouse} style={{
          height: "350px",
          width: "600px"
        }} mdxType="Image" />
        <h1>{`Lighthouse`}</h1>
        <ul>
          <li parentName="ul">{`Google Chrome Dev Tools`}</li>
          <li parentName="ul">{`Measure performance, accessibility, best practices, SEO, and PWA`}</li>
        </ul>
      </Split>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`On the client side...`}</p>
      <p>{`Lighthouse is a tool built into Google Chrome Dev Tools that will give you a view of the performance of your website.  It will give you a score for performance, accessibility, best practices, SEO.  `}</p>
      <p>{`This is a great tool to help you understand the impact of your website and to help you make decisions about how to optimize it.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">  
      <Split mdxType="Split">
        <Image src={WebsiteCarbon} style={{
          height: "450px",
          width: "500px"
        }} mdxType="Image" />
        <h1>{`WebsiteCarbon.com`}</h1>
      </Split>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`WebsiteCarbon.com is a tool that will give you a view of the carbon footprint of your website.  `}</p>
      <p>{`My tackaberry.dev site, as you saw on the lighthouse view in the last slide too, is set up well.  A SSG website, deployed to GCP Cloud Storage, with a CDN in front of it is a very efficient website.  `}</p>
    </Notes> 
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`2. Education and awareness`}</h1>
      <ul>
        <li parentName="ul">{`Green Software Foundation has great training`}</li>
        <li parentName="ul">{`Find some support around the office or stakeholders`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The next step in your journey will be to educate yourself and your team.  There are a number of great resources out there.  The Green Software Foundation has some great training.`}</p>
      <p>{`You also might have to build some awareness with others on your team, or with owners or other stakeholders.  You might have to build a business case.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`3. Do the work`}</h1>
      <ul>
        <li parentName="ul">{`Find the easy wins - High Impact, Low Effort `}</li>
        <li parentName="ul">{`Can you move to Green Hosting`}</li>
        <li parentName="ul">{`Eliminate dark data`}</li>
        <li parentName="ul">{`Optimize front end`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The start to do the work.`}</p>
      <ul>
        <li parentName="ul">{`Find the easy wins - High Impact, Low Effort `}</li>
        <li parentName="ul">{`Can you move to Green Hosting?`}</li>
        <li parentName="ul">{`Can you delete duplicate data? Do you have an automated backup procesS?`}</li>
        <li parentName="ul">{`Then, Optimize front end`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout color={DARK_PINK} mdxType="Layout">
      <h1>{`4. Measure and Improve`}</h1>
      <ul>
        <li parentName="ul">{`Measure and Optimize`}</li>
        <li parentName="ul">{`Continuous improvement`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The next step is to start to automate, integrate measurement and improvement into your CI/CD, and start to operationalize performance and sustainability measurement.`}</p>
      <p>{`And improve. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`5. Modernize`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Lastly, start to modernize. Introduce new sustainability features into your product roadmap. Work through the guidelines.`}</p>
      <p>{`And fix the planet.  It's that easy. `}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`Cloud Sustainability: A Practical Guide for Building a More Sustainable Internet`}</h1>
      <ul>
        <li parentName="ul">{`Cloud Native Computing Foundation Meetup`}</li>
        <li parentName="ul">{`6pm - Nov 28, 2023 - Impact Hub Ottawa`}</li>
        <li parentName="ul">{`Data, Security, CI/CD, Open-source, K8s optimization, and more`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
    </Notes>
    <hr></hr>
    <Layout color="BLACK" mdxType="Layout">
      <Split mdxType="Split">
        <Image src={QrCode} style={{
          height: "400px",
          width: "400px"
        }} mdxType="Image" /> 
        <h1>{`Thank you 🙏`}</h1>
        <ul>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://www.linkedin.com/in/tackaberry/"
              }}>{`https://www.linkedin.com/in/tackaberry/`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://github.com/tackaberry"
              }}>{`https://github.com/tackaberry`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://ottawajs-w3c-web-sustainability-guidelines.tackaberry.dev/"
              }}>{`This Presentation`}</a></p>
          </li>
        </ul>
      </Split>
    </Layout>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;